import { searchMailsElastic } from './message';
import { enrichItemsWithReadStatuses } from './read-status';
import { setFiltersApplied } from '../actions/application';
import { clearSelected } from '../actions/messages';

/**
 * Execute Elastic search, enrich with read statuses, clear selection, and dispatch filtersApplied.
 * Returns { items, totalHits, from, size }.
 */
export async function runSearchAndApply(dispatch, { userId, account, lexonToken, body }) {
  const result = await searchMailsElastic(
    dispatch,
    userId,
    account,
    body,
    { lexonToken }
  );

  const items = (result && result.data && result.data.items) ? result.data.items : [];
  const enrichedItems = await enrichItemsWithReadStatuses(dispatch, items, userId, account, lexonToken);

  dispatch(clearSelected());
  dispatch(setFiltersApplied(
    body,
    enrichedItems,
    result && result.data ? result.data.totalHits : 0,
    result && result.data ? result.data.from : 0,
    result && result.data ? result.data.size : 0
  ));

  return {
    items: enrichedItems,
    totalHits: result && result.data ? result.data.totalHits : 0,
    from: result && result.data ? result.data.from : 0,
    size: result && result.data ? result.data.size : 0
  };
}